import React, { useEffect, useRef, useState } from "react";
import { pubCall } from "../utils/PubSub";
import Button from "../ui/Button";
import { InfoIcon } from "../utils/Icons";
import Status from "../ui/Status";
import Label from "../ui/Label";
import Input from "../ui/Input";
import Space from "../ui/Space";
import Divider from "../ui/Divider";
import { VALIDATE } from "../utils/Validators";
import Checkbox from "../ui/Checkbox";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { drawPicker } from "../popovers/Picker";
import { showError } from "../ui/Message";
import Spin from "../ui/Spin";
import { ucfirst } from "../utils/Utils";

export default function TitleLinkSearch(props) {




    const { callback = () => { }, route = "", term = "", type = "", supplier = "", bisac = "" } = props;

    const refs = useRef([]);
    const [index, setIndex] = useState("sort");
    const [loading, setLoading] = useState(false);

    const [tabs, setTabs] = useState([
        { key: "limit", value: 100 },
        { key: "sort", value: "I" },
        { key: "scope", value: "A" },
        { key: "default", value: true },
    ])

    const update = (_key, value) => {
        let _t = [...tabs];
        setTabs(_t.map(tab => tab.key === _key ? { ...tab, value: value } : tab)
        );
    }

    const getVal = (_key) => {
        return tabs.find(item => item.key === _key).value
    }

    const status = {
        limit: "Range between 1 and 100.",
        sort: <>Instock = your stock first, then most popular including forthcoming.</>,
        scope: <></>,
        default: <></>
    }



    const searchTitleLink = () => {

        setLoading(true);

        let _scope = getVal("scope");
        _scope = (_scope === "B") ? "both" : (_scope === "I") ? "inactive" : "active";

        let _sort = getVal("sort");
        _sort = (_sort === "R") ? "rank" : (_sort === "I") ? "in_stock" : (_sort === "P") ? "pubdate" : (_sort === "T") ? "title" : "author";

        let _limit = getVal("limit");
        // rank/in_stock/pubdate/title/author
        let _params = {
            term: term,
            type: type,
            scope: _scope,
            sort: _sort,
            limit: _limit
        };

        if (supplier) { _params.supplier = supplier }
        if (bisac) { _params.bisac = bisac; _params.term = "" }

        pubCall("title_link.search", _params, (_s, _r) => {
            if (_s) {
                _r = _r.rows.map((item, index) => {
                    let _i = (item.stock) ? { ...item.stock } : { stock_id: "no-stock" + index }
                    _i.title_link = item.title_link;

                    return _i;
                })
                let searchMsg = "";
                searchMsg = <>Search results: <span className="text-light">{_r.length}</span> matches using <span className="text-light">{ucfirst(props.sterm)}:</span> <em className="text-yellow">'{term}'</em>.</>;
                callback({ data: _r, search: searchMsg });
            } else {
                showError(_r);
            }
            setLoading(false)
        });
    }

    const editProps = (index) => ({
        onFocus: () => setIndex(index),
        ref: (e) => (refs.current[index] = e),
        edit: true,
        controlled: true,
        autoselect: true,
        onChange: (e) => update(index, e)
    });


    const next = () => {
        const currentIndex = tabs.findIndex(tab => tab.key === index);
        if (currentIndex !== -1 && currentIndex < tabs.length - 1) { return setIndex(tabs[currentIndex + 1].key); }
        return setIndex(tabs[0].key);
    };

    const prev = () => {
        const currentIndex = tabs.findIndex(tab => tab.key === index);
        if (currentIndex > 0) { return setIndex(tabs[currentIndex - 1].key); }
        return setIndex(tabs[tabs.length - 1].key);
    };


    const onEnter = () => {
        switch (index) {
            case "default":
                setTabs(prevTabs =>
                    prevTabs.map(tab =>
                        tab.key === "default" ? { ...tab, value: !tab.value } : tab
                    )
                );
                break;
            case "sort":
                drawPicker({ value: getVal("sort"), ref: refs.current["sort"], route: route, callback: (e) => update("sort", e), offset: [0, -46], options: [{ value: "I", label: "In stock" }, { value: "F", label: "Forthcoming" }, { value: "R", label: "Rank" }, { value: "P", label: "Pubdate" }, { value: "T", label: "Title" }] })
                break;
            case "scope":
                drawPicker({ value: getVal("scope"), ref: refs.current["scope"], route: route, callback: (e) => update("scope", e), offset: [0, -26], options: [{ label: "Inactive", value: "I" }, { label: "Active", value: "A" }, { label: "Both", value: "B" }] })
                break;
        }
    }

    // Keyboard Events
    useEffect(() => {

        if (loading) {
            return;
        }

        if (refs?.current[index]) {
            refs.current[index].focus();
        }

        const actions = [
            { key: KBD.ARROW_DOWN, action: (e) => next() },
            { key: KBD.ARROW_UP, action: (e) => prev() },
            { key: KBD.TAB, action: (e) => { next() } },
            { key: KBD.SHIFT_TAB, action: (e) => { prev() } },
            { key: KBD.ESCAPE, action: (e) => callback(false) },
            { key: KBD.PAGE_UP, action: (e) => { searchTitleLink() } },
            { key: KBD.ENTER, action: (e) => { onEnter() } }
        ];
        const cleanup = listen(route, actions, (e) => {
            if (e.deltaY > 0) {
                next();
            } else {
                prev();
            }
        }, [KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.TAB, KBD.SHIFT_TAB, KBD.ESCAPE, KBD.ENTER, KBD.PAGE_UP, KBD.PAGE_DOWN, KBD.CTRL_C, KBD.CTRL_V], [], [KBD.CTRL_C, KBD.CTRL_V]);
        return cleanup;
    }, [index, update, loading]);




    return (

        <Spin style={{ "margin": "0px -10px" }} loading={loading} message={<Label>Searching...</Label>}>
            <div style={{ "width": "520px", "padding": "0px 10px" }}>
                <div className="shim" /><div className="shim" /><div className="shim" />
                <Space height={25} size={10}>
                    <Label width={110}>Maximum results</Label><Divider vertical />
                    <Input {...editProps("limit")} maxLength={3} number number_default={null} autoselect validator={VALIDATE.RANGE(1, 100)} placeholder="" width={50} edit value={getVal("limit")} />
                </Space>
                <div className="shim" />
                <Space height={25} size={10}>
                    <Label width={110}>Sort results by:</Label><Divider vertical />
                    <Input doubleclick={KBD.ENTER} {...editProps("sort")} style={{ "textAlign": "center" }} maxLength={1} chars={["I", "F", "R", "P", "T", ""]} autoselect validator={VALIDATE.CHARS(["I", "F", "R", "P", "T"], false)} edit uppercase width={20} value={getVal("sort")} />
                    <Label>(Instock Forthcoming Rank Pubdate Title)</Label>
                </Space>
                <div className="shim" />
                <Space height={25} size={10}>
                    <Label width={110}>Scope:</Label><Divider vertical />
                    <Input doubleclick={KBD.ENTER} {...editProps("scope")} style={{ "textAlign": "center" }} maxLength={1} chars={["I", "A", "B", ""]} autoselect validator={VALIDATE.CHARS(["I", "A", "B"], false)} edit uppercase width={20} value={getVal("scope")} />
                    <Label>(Active Inactive Both)</Label>
                </Space>
                <div className="shim" />
                <Space height={25} size={10}>
                    <Label width={110}>Set as default?</Label><Divider vertical />
                    <Checkbox value={tabs.find(item => item.key === "default").value} {...editProps("default")} ></Checkbox>
                </Space>
                <div style={{ "textAlign": "center" }}><small className="label">Press <strong>{KBD.PAGE_UP.label}</strong> to search Titlelink.</small></div>
                <div className="shim" /><div className="shim" />
                <Status><InfoIcon /> {status[index]}</Status>
            </div>
        </Spin>
    )
}